export default __webpack_public_path__ + "static/media/TheBestDish.13846e8f.png";